import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAuftrag, IAuftragChangeStatusRequest, IAuftragRequest, IAuftragTerminiereRequest, IAuftragWiedervorlageRequest, ITicket, ITicketRequest } from "../types/Types";

/**
 * @author mb
 */
export const TicketAPI = createApi({
    reducerPath: "ticketAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "ticket",
            credentials: 'include'
        }),
    tagTypes: ['ticketAPI'], // for caching
    endpoints: (builder) => ({
        getTicketListe: builder.mutation<ITicket[], void>(
            {
                query: () => ({
                    url: '/',
                    method: 'get',
                    credentials: 'include'
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),
        getTicket: builder.mutation<any, string>(
            {
                query: (uid) => ({
                    url: '/' + uid,
                    method: 'get',
                    credentials: 'include'
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),
        createOrUpdateTicket: builder.mutation<ITicket, ITicketRequest>(
            {
                query: (dto: ITicketRequest) => ({
                    url: 'createOrUpdate',
                    method: 'put',
                    credentials: 'include',
                    body: dto
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),
        deleteTicket: builder.mutation<ITicket, string>(
            {
                query: (uid) => ({
                    url: '' + uid,
                    method: 'delete',
                    params: {
                    },
                    credentials: 'include'
                }),
                invalidatesTags: ["ticketAPI"],
            }
        ),


    })
});

export const {

    useGetTicketListeMutation,
    useCreateOrUpdateTicketMutation,
    useGetTicketMutation,
    useDeleteTicketMutation,

} = TicketAPI;
